module.exports = __webpack_public_path__ + "img/NPCM.a9e9d1a2.svg";